"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLeitungModel = exports.LeitungBeschriftung = void 0;
const echain_product_models_1 = require("@igus/echain-product-models");
var LeitungBeschriftung;
(function (LeitungBeschriftung) {
    LeitungBeschriftung["keine"] = "Keine";
    LeitungBeschriftung["folienlabel"] = "Folienlabel";
})(LeitungBeschriftung = exports.LeitungBeschriftung || (exports.LeitungBeschriftung = {}));
const isLeitungModel = (something) => {
    const possibleLeitungModel = something;
    return (0, echain_product_models_1.isLeitungApp)(something) && (!(possibleLeitungModel === null || possibleLeitungModel === void 0 ? void 0 : possibleLeitungModel.Chainflex) || (0, echain_product_models_1.isLeitungApp)(possibleLeitungModel.Chainflex));
};
exports.isLeitungModel = isLeitungModel;
//# sourceMappingURL=LeitungModel.js.map